module.exports = __webpack_public_path__ + "static/media/FENGYUN 3B.398d81d2.czml";